module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("BLUE YODEL 5")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-subtitle1"
  }, [_c('span', [_vm._v("VINNIE AND DOM")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VINNIE")]), _vm._v(": … things these days. My mother wants to know why I won’t let her ride the bus to St. Mary the Virgin. I say, “Because you got bit in the back of the neck, Ma.” Guy on the bus bit my mother in the back of the neck! I hit the guy … I")]), _vm._v(" found "), _c('i', [_vm._v("the guy. I hit the guy")]), _vm._v("…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DOM")]), _vm._v(": Guys like that shouldn’t be hit. Guys like that, you should kill ’em")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('i', [_vm._v("VINNIE")]), _vm._v(":")]), _vm._v(" "), _c('i', [_vm._v("I beat the")]), _vm._v(" shit "), _c('i', [_vm._v("out of the guy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DOM")]), _vm._v(": Guys like that, you shouldn’t beat the shit out of them. You should kill guys like that")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VINNIE")]), _vm._v(": She says she wishes she didn’t tell me. I say, “Ma, you")]), _vm._v(" told "), _c('i', [_vm._v("me. Just go to St. Francis’s up the block here.” She says but at St. Mary the Virgin the stations of the cross are prettier. I say, “Ma, our Savior didn’t tell us, seek out a place with pretty stations of the cross to go to mass.” She says she don’t understand. I say, “Ma, you have to listen to me now. If you don’t understand, I can’t tell you. Don’t take the bus no more")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DOM")]), _vm._v(": Guys like that, you ought to kill ’em")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VINNIE")]), _vm._v(": What does she want me to say? “You want a son that went to the penitentiary for murder and had to fight off six-foot-six black bodybuilder fruits with a sharpened bedspring for the rest of his life because you got to ride the bus to see the prettier stations of the cross at St. Mary the Virgin?”?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DOM")]), _vm._v(": Just kill ’em. That’s all")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a79c044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/chapter09.vue
// module id = 111
// module chunks = 0